const SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i

// Program.url comes from psp-backend/programs (Mongo collection `ia/programs`) with no
// normalization on the backend side. In some environments it's stored without a scheme
// (e.g. "commessademo-demo-portal.example.eu"), which browsers resolve as a path relative
// to the current page instead of navigating to the other portal.
export function buildPortalUrl(
  baseUrl: string,
  params: Record<string, string | undefined> = {}
): string {
  const trimmed = (baseUrl ?? '').trim()
  if (!trimmed) {
    return baseUrl
  }

  const absolute = SCHEME.test(trimmed) ? trimmed : `https://${trimmed.replace(/^\/+/, '')}`

  try {
    const url = new URL(absolute)
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value)
      }
    })
    return url.href
  } catch {
    return baseUrl
  }
}
